var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid grid-flow-row auto-rows-max gap-2" },
    [
      _c("div", [_vm._v(" " + _vm._s(_vm.user.name) + " ")]),
      _c("div", [_vm._v(" " + _vm._s(_vm.user.email) + " ")]),
      _c(
        "div",
        { staticClass: "mt-8" },
        [
          _c("pui-link", {
            attrs: {
              icon: "duplicate",
              title: _vm.$t("profile.copyAccessToken")
            },
            on: {
              click: function($event) {
                return _vm.copyToken()
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c("pui-link", {
            attrs: {
              href: _vm.swaggerURL,
              target: "_blank",
              icon: "report",
              title: _vm.$t("profile.openSwagger")
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "mt-6" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("profile.version") + " " + _vm.version) + " "
        )
      ]),
      _c("div", { staticClass: "pb-4" }, [
        _vm._v(" " + _vm._s(_vm.$t("profile.apiUrl")) + " "),
        _c("a", { attrs: { href: _vm.apiUrl } }, [
          _vm._v(" " + _vm._s(_vm.apiUrl) + " ")
        ])
      ]),
      _c(
        "pui-button",
        {
          staticClass: "profile-action-button",
          attrs: { state: "secondary", icon: "report" },
          on: {
            click: function($event) {
              return _vm.sendFeedback()
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t("sendFeedback")) + " ")]
      ),
      _c(
        "pui-button",
        {
          staticClass: "profile-action-button profile-action-button--important",
          attrs: { state: "secondary", icon: "warning" },
          on: {
            click: function($event) {
              return _vm.goToQueryHub()
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t("profile.goToQueryHub")) + " ")]
      ),
      _c(
        "pui-button",
        {
          staticClass: "profile-action-button profile-action-button--important",
          attrs: { state: "secondary", icon: "warning" },
          on: {
            click: function($event) {
              return _vm.reportIncident()
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t("reportIncident")) + " ")]
      ),
      _c(
        "pui-button",
        {
          staticClass: "profile-action-button",
          attrs: { icon: "power" },
          on: {
            click: function($event) {
              return _vm.logOut()
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t("signOut")) + " ")]
      ),
      _c("input", {
        staticClass: "copy-text",
        attrs: { id: "copyText", type: "text" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }